import {rebuildPathWithParams} from '@salesforce/retail-react-app/app/utils/url'
import {useMemo} from 'react'
import {getPriceData} from '../utils/product-utils'
import {PRODUCT_CUSTOM_SELECTABLE_ATTRIBUTE_ID} from '../constants'
import {productUrlBuilder} from '../utils/url'

export function getProductUrl(product) {
    const {productId, representedProduct} = product
    const comparisonId = representedProduct ? product.representedProduct.id : product?.id
    const productUrlParams = productId
        ? {id: productId, params: {pid: comparisonId}}
        : !product.c_subModelIdentifier || product.c_subModelIdentifier === product.id
        ? {id: product.id, params: {}}
        : {id: product.c_subModelIdentifier, params: {pid: comparisonId}}

    return rebuildPathWithParams(productUrlBuilder(product), productUrlParams.params)
}

const useProductData = (
    product,
    selectableAttributeId = PRODUCT_CUSTOM_SELECTABLE_ATTRIBUTE_ID,
) => {
    const {productId, representedProduct, variants} = product

    const isMasterVariant = !!variants
    const comparisonId = representedProduct ? product.representedProduct.id : product?.id
    const selectableAttributeValue =
        isMasterVariant && comparisonId
            ? variants?.find((variant) => variant.productId == comparisonId)?.variationValues?.[
                  selectableAttributeId
              ]
            : undefined

    /*
    Fix to make it working without representedProduct
    */
    const productUrlParams = productId
        ? {id: productId, params: {pid: comparisonId}}
        : !product.c_subModelIdentifier || product.c_subModelIdentifier === product.id
        ? {id: product.id, params: {}}
        : {id: product.c_subModelIdentifier, params: {pid: comparisonId}}

    const productUrl = useMemo(
        () => rebuildPathWithParams(productUrlBuilder(product), productUrlParams.params),
        [product, selectableAttributeId, selectableAttributeValue],
    )

    const productWithFilteredVariants = useMemo(() => {
        const variants = product?.c_variants?.filter(({variationValues}) => {
            return variationValues[selectableAttributeId] === selectableAttributeValue
        })
        return {
            ...product,
            variants,
        }
    }, [product, selectableAttributeId, selectableAttributeValue])
    var opts = {}
    if (productWithFilteredVariants?.quantity > 1) {
        opts = {
            quantity: productWithFilteredVariants?.quantity,
        }
    }
    // Pricing is dynamic! Ensure we are showing the right price for the selected variation attribute
    // value.
    const priceData = useMemo(() => {
        return getPriceData(productWithFilteredVariants, opts)
    }, [productWithFilteredVariants])

    return {productUrl, priceData}
}

export default useProductData
